import { useIfcMode } from '@editorHooks'

interface Settings {
  isSettingsActive: boolean
  toggleSettings: () => void
  closeSettings: () => void
}

/**
 * IFC model settings panel state for the IFC Import page, backed by the global editor mode
 * (`'ifc-settings'`). While active, the page drawer shows the IFC title field and delete button.
 */
const useIFCImportSettings = (): Settings => {
  const { ifcMode, setIfcMode } = useIfcMode()

  const isSettingsActive = ifcMode === 'settings'

  const toggleSettings = () => setIfcMode(isSettingsActive ? null : 'settings')
  const closeSettings = () => setIfcMode(null)

  return { isSettingsActive, toggleSettings, closeSettings }
}

export default useIFCImportSettings
